/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscPhoneinfo } from "../../funcs/miscGetMiscPhoneinfo.js";
import { GetMiscPhoneinfoRequest$zodSchema } from "../../models/getmiscphoneinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscPhoneinfoRequest$zodSchema,
};

export const tool$miscGetMiscPhoneinfo: ToolDefinition<typeof args> = {
  name: "misc-get-misc-phoneinfo",
  description: `查询手机归属地

想知道一个手机号码来自哪里？是移动、联通还是电信？这个接口可以告诉你答案。

## 功能概述
提供一个国内的手机号码，我们会查询并返回它的归属地（省份和城市）以及所属的运营商信息。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscPhoneinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
